import { useState } from 'react'
import { Card, CardBody, Col, Toast, ToastBody, ToastHeader } from 'reactstrap';
import { StackingToast } from '../../../../Utils/Constants';
import { Bell } from 'react-feather';
import { stackingToastData, stackingToastDataList } from '../../../../Data/BonusUi/Toast/Toast';
import CommonToast from '../Common/CommonToast';
import { Btn } from '../../../../AbstractElements';
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon';

const StackingToasts = () => {
    const [open, setopen] = useState(true);

    return (
      <Col md="6">
        <Card>
          <CardHeaderCommon title={StackingToast} span={stackingToastData} />
          <CardBody className="toast-rtl">
            <div className="toast-container position-static">
              <Toast isOpen={open}>
                <ToastHeader className='stacking-toast'>
                  <Bell className="toast-icons toast-primary" />
                  <div>Lagos theme</div>
                  <small className="txt-danger m-auto">just now</small>
                  <Btn close className="p-0" onClick={() => setopen(false)}></Btn>
                </ToastHeader>
                <ToastBody className="toast-dark">Hello, I'm a web-designer.</ToastBody>
              </Toast>
              {stackingToastDataList.map((data, index) => (
                <CommonToast item={data} key={index} />
              ))}
            </div>
          </CardBody>
        </Card>
      </Col>
    );
}

export default StackingToasts